import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import {
  armarFilasDelSlider,
  manejadorDeRespuesta,
} from "../../../utils/Tools";
import BancosSlider from "../../Home/BancosSlider";
import Loader from "../../Global/Loader";
import SeccionBuscador from "../../Home/SeccionBuscador";
import { cdrAPI } from "../../../utils/funcionesAPI";
import DestinoFila from "../../Home/DestinoFila";
import Modal from "../../Global/Modal";

const Hoteles = (props) => {
  const [loaded, setLoaded] = useState(false);
  const [productos, setProductos] = useState([]);
  const [fancy, ] = useState({});

  const traerOfertaDeHotelesParaHome = () => {
    let data = JSON.stringify({
      peticion: "traerOfertaDeHotelesParaHome",
    });
    setLoaded(false);
    cdrAPI(data).then((respuesta) => {
      setLoaded(true);
      if (manejadorDeRespuesta(props, respuesta)) setProductos(respuesta.data);
    });
  };

  useEffect(() => {
    traerOfertaDeHotelesParaHome();
  }, []);
  /*
  const estilos = {
    estiloDestinos: "col-sm-3",
    estilo1: "col-sm-2",
    estilosInputs: "",
    estilosInputFecha: "",
    estiloBoton: "",
    estiloEdadMenor: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12",
  };
  */
  const { productos1raFila, productos2daFila, productos3raFila } =
    armarFilasDelSlider(productos);

  return (
    <div>
      <SeccionBuscador origen="CDR" />
      
      <Loader
        loaded={loaded}
        mensaje="Buscando Hoteles, aguarde unos instantes..."
      />
      {loaded && (
        <div style={{marginTop: '1rem'}}>
          {productos1raFila.length > 0 && (
            <DestinoFila
              titulo="Destacados"
              productos={productos1raFila}
              origen="CDR"
            />
          )}
          {/*---SI HAY MAS DE 8 PRODUCTOS MUESTRO LA 2da FILA---*/}
          {productos2daFila.length > 3 && (
            <DestinoFila
              titulo="Otros Destinos"
              productos={productos2daFila}
              origen="CDR"
            />
          )}
          {/*---SI HAY MAS DE 12 PRODUCTOS MUESTRO LA 2da FILA---*/}
          {productos3raFila.length > 3 && (
            <DestinoFila
              titulo="Además"
              productos={productos3raFila}
              origen="CDR"
            />
          )}
        </div>
      )}

      <BancosSlider />

      <ToastContainer />
      {/*---MOSTRAR MODAL HASTA FECHA FINALIZACION ---*/}
      {fancy.estado &&
      new Date().getTime() <= fancy.fechaFinalizacion.getTime() ? (
        <Modal fancy={fancy} />
      ) : null}
     {/*  <div
        className="d-lg-none"
        style={{
          display: "block",
          width: "70px",
          height: "70px",
          color: "#fff",
          position: "fixed",
          right: "20px",
          bottom: "20px",
          borderRadius: "50%",
          lineHeight: "80px",
          textAlign: "center",
          zIndex: "999",
        }}
      >
        <a href="https://pedraza.com.ar/turnos">
          <img
            src="https://pedraza.com.ar/assets/img/ico-turnos.png"
            alt="Logo Turnos"
          />
        </a>
      </div> */}
    </div>
  );
};

export default Hoteles;
/*
 constructor(props) {
      super(props)
      this.state = {hoteles: [{codigo:186,nombre:'San Miguel Plaza Golf & Spa',imagen:'hoteles/hotel_san_miguel.jpg',localidad:'Valle de Paravachasca',provincia:'Córdoba'},
                              {codigo:185,nombre:'Hotel Villa de Merlo Spa',imagen:'hoteles/villaDeMerlo.jpg',localidad:'Merlo',provincia:'San Luis'},
                              {codigo:183,nombre:'Grand Hotel Rio Hondo',imagen:'hoteles/GrandHotelTermas.jpg',localidad:'Termas de Rio Hondo',provincia:'Santiago del Estero'},
                              {codigo:184,nombre:'Hotel Kalken',imagen:'hoteles/KalafateHotel.jpg',localidad:'Calafate',provincia:'Santa Cruz'},
                              {codigo:182,nombre:'Hotel Lyon',imagen:'hoteles/hotel_lyon.jpg',localidad:'Capital Federal',provincia:'Buenos Aires'},
                              {codigo:241,nombre:'Hotel Azul',imagen:'hoteles/hotel_azul2.jpg',localidad:'Punta del Este',provincia:'Uruguay'}
                             ],
                    datos:{codigo:186,fechaDesde:deJSAFechaAmericana(new Date()),fechaHasta:deJSAFechaAmericana(new Date()),url:'www.magnahoteles.com'},
                  };
                  this.handleComboSelectedForm = this.handleComboSelectedForm.bind(this);
                  this.handleClikBuscarEnHotel = this.handleClikBuscarEnHotel.bind(this);
  }
*/
/*
  const handleComboSelectedForm = (propiedad, valor) => {
    let datos = Object.assign({}, this.state.datos);
    datos[propiedad] = valor;
    setDatos(datos);
  };
*/
/*
  const handleClikBuscarEnHotel = () => {
    /*
    let datos = Object.assign({}, datos);
    const codigo = datos.codigo; 
    const fechaDesde = datos.fechaDesde;
    const fechaHasta = datos.fechaHasta;
    //datos.url = "https://www.todoalojamiento.com/portal/?idHotel="+ codigo + "&fechaDesde="+ fechaDesde + "&fechaHasta=" + fechaHasta;
    this.setState({datos});
    
  };
*/



// WEBPACK FOOTER //
// ./src/components/Hoteles/Home/index.js